import _pickBy from 'lodash/pickBy';
import 'prop-types';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';
import rison from 'rison-node';
import { QUERY_PARAMETERS_COUNTED_IN_THE_CACHE_KEY } from '@dbh/cloudflare-worker-constants';
import '@dbh/generic-types';
import { DBH_QUERY_PARAMETER_NAME, decodeQueryParameter, makeLocationSearch } from '@dbh/make-api-url';

/*
 *
 * `isAnalyticsQueryParameter`: `@dbh/tracking-url-utils`.
 *
 */const utmRegex=/^utm_/i,gadRegex=/^gad_/i,braidRegex=/^(g|w)braid$/i,knownExact=new Set(["gclid","gad"]),isAnalyticsQueryParameter=a=>"string"==typeof a&&(knownExact.has(a)||utmRegex.test(a)||gadRegex.test(a)||braidRegex.test(a));/**
 * Is the input an "Analytics" related key (@example `utm_source`).
 * @param {string} key Query parameter key to check.
 * @return {boolean} Is `key` an "Analytics" related key.
 */var isAnalyticsQueryParameter$1 = isAnalyticsQueryParameter;

/**
 * Given a `req.query` like object, returns a subset of all its "Analytics"
 * related keys (@example `utm_source`).
 * @param {Object?} query Mapping between query keys and query parameter values.
 * @return {Object} Subset of all the "Analytics" related keys of the `query`.
 * @see {@link https://expressjs.com/en/4x/api.html#req.query}
 */const pickAnalyticsQueryParams=withConformsTo("pickAnalyticsQueryParams",[],a=>a?_pickBy(a,(a,b)=>isAnalyticsQueryParameter$1(b)):{});var pickAnalyticsQueryParams$1 = pickAnalyticsQueryParams;

/**
 * Returns the URL fields for the `BigQuery` tables we use to store front end
 * HTTPS access logs, redacting query params if `GDPR` consent is not given.
 * @param {string} urlString .
 * @param {Object} options .
 * @param {boolean} options.arePerformanceCookiesAllowed .
 * @param {boolean} options.areTargetingCookiesAllowed .
 * @return {{url:string,urlQuery:string,urlPathname:string,urlHost:string}}
 */const gdprifyUrl=withConformsTo("gdprifyUrl",[],(a,b)=>{let{arePerformanceCookiesAllowed:c,areTargetingCookiesAllowed:d}=b;const e=new URL(a),f=e.pathname;if(!c||!d){const a=e.searchParams,b=new Set(QUERY_PARAMETERS_COUNTED_IN_THE_CACHE_KEY.map(a=>a.toLowerCase())),c=(a,c)=>{const e=a.toLowerCase();return ("utm_source"!==e||"staff"!==c)&&e!==DBH_QUERY_PARAMETER_NAME&&(!!b.has(e)||!d&&isAnalyticsQueryParameter$1(a));// Never process the special `dbhq` param in this loop.
// Always‑sensitive keys (`email`, `token`, `guid*`, …).
// Marketing and tracking keys (`gclid`, `utm_*`, ...) get removed only
// when the visitor rejected targeting cookies.
};// Decide if a top‑level query‑string key should be redacted.
// Walk the flat query-string parameters.
// `Rison` (`dbhq`) recursive param redaction.
if(a.forEach((b,d)=>{c(d,b)&&a.set(d,"GDPR-REDACTED");}),a.has(DBH_QUERY_PARAMETER_NAME)){const c=a.get(DBH_QUERY_PARAMETER_NAME),e=decodeQueryParameter(c);let f;try{f=rison.decode(e);}catch{f=null;}if(f&&"object"==typeof f){// Deep walk the object so nested keys are also redacted.
const c=a=>{const e=a;e&&"object"==typeof e&&Object.keys(e).forEach(a=>{b.has(a.toLowerCase())||!d&&isAnalyticsQueryParameter$1(a)?e[a]="GDPR-REDACTED":c(e[a]);});};c(f);// Re‑encode to `Rison`.
const e=makeLocationSearch(f,!0);a.set(DBH_QUERY_PARAMETER_NAME,e.replace("?"+DBH_QUERY_PARAMETER_NAME+"=",""));}}}const{href:g,searchParams:h}=e,i=[...h],j=Object.fromEntries(i),k=i.length?JSON.stringify(j):null;return {url:g,urlQuery:k,urlPathname:f,urlHost:e.host}});var gdprifyUrl$1 = gdprifyUrl;

export { gdprifyUrl$1 as gdprifyUrl, isAnalyticsQueryParameter$1 as isAnalyticsQueryParameter, pickAnalyticsQueryParams$1 as pickAnalyticsQueryParams };
